import { __read, __spreadArray } from "tslib";
import { getUrlMappingVariablesSchema, } from './types';
export var getDefaultMapping = function (urlMappingKey, pathPrefix) {
    var _a, _b;
    var _c = getUrlMappingVariablesSchema()[urlMappingKey] || {
        required: ['slug'],
    }, required = _c.required, defaultPrefix = _c.defaultPrefix;
    if (pathPrefix && typeof pathPrefix === 'object') {
        pathPrefix = (_b = (_a = pathPrefix.publishedPrefix) !== null && _a !== void 0 ? _a : pathPrefix.savedPrefix) !== null && _b !== void 0 ? _b : '';
    }
    return __spreadArray([pathPrefix, defaultPrefix], __read(required === null || required === void 0 ? void 0 : required.map(function (main) { return "{{".concat(main, "}}"); })), false).filter(Boolean)
        .join('/');
};
//# sourceMappingURL=get-default-mapping.js.map